"use client";

import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import React from "react";

export function Provider(props) {
  return (
    <ChakraProvider value={defaultSystem}>
      <div className="chakra-provider">{props.children}</div>
    </ChakraProvider>
  );
}
